function StyledError({ children }: { children: React.ReactNode }) {
  return <p className="text-ion-color-danger">{children}</p>
}

export { StyledError }
